export default __webpack_public_path__ + "static/media/4450.7bc0d706.png";